import { lazy, Suspense } from 'react'
import WithBackgroundImage from '../BackgroundImage'
import AdminStatusIndicator from './AdminStatusIndicator'
import { Stack, Skeleton, Box } from '@chakra-ui/react'

// Lazy load heavy components that appear below the fold
const Calendar = lazy(() => import('../Calendar/Calendar'))
const CommunityBlog = lazy(() => import('../Community'))
const GridBlurredBackdrop = lazy(() => import('../Noteworthy'))

// Minimal skeleton for below-fold content
const SectionSkeleton = () => (
  <Box w="full" maxW="1200px" px={4}>
    <Skeleton height="300px" borderRadius="lg" />
  </Box>
)

export default function Home() {
  return (
    <>
      <AdminStatusIndicator />
      <Stack
        direction="column"
        align="center"
        justify="center"
        w="100%"
        spacing={6}
        id="home"
      >
        {/* Above-fold content loads immediately */}
        <WithBackgroundImage />
        
        {/* Below-fold content lazy loads */}
        <Suspense fallback={<SectionSkeleton />}>
          <Calendar />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <CommunityBlog id="new" />
        </Suspense>
        <Suspense fallback={<SectionSkeleton />}>
          <GridBlurredBackdrop />
        </Suspense>
      </Stack>
    </>
  )
}
